export const abbreviateDayOfWeek = (day: DayOfWeek) => day.slice(0, 3)
